// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3U_FT","right":"Footer_right__CA8P9","buttons":"Footer_buttons__2rnG9"};